import { GrowpIcon } from 'packages/components/GrowpIcon'
import { PermEnum } from 'packages/sdks-next/growp'
import { MenuItemUnion } from 'packages/web-layout/types'

export const useSystemSettingMenu: () => MenuItemUnion[] = () => {
  return [
    {
      path: '/admin/systemSetting',
      label: (
        <GrowpIcon
          name="Setting"
          text="系统设置"
          size={14}
          textMarginLeft={16}
        />
      ),
      labelText: '系统设置',
      height: 40,
      perm: PermEnum.System,
    },
  ]
}
